import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Button, Form, Spinner, Modal } from "react-bootstrap";
import { FaEdit } from 'react-icons/fa';
import Select from 'react-select';
import { setSESProductQtyChanges, getSESProducts } from '../../actions';
import { getTranslate, LANGUAGE_KEYS } from '../../utils/language';

class SESProductQtyChangeModal extends Component {
  state = {
    mode: this.props.mode || 'view',
    formData: null,
    saving: false
  };

  getDefaultFormData = () => ({
    product_code: '',
    warehouse_id: 1,
    warehouse_cell_code: '',
    old_quantity: 0,
    quantity: 0,
    quantity_change: 0,
    type: 'IMPORT',
    reference_id: '',
    system_note: '',
    staff_note: '',
    updated_by: '',
    is_deleted: false
  });

  componentDidMount() {
    this.initializeFormData();
    // Load all products without pagination
    this.props.getSESProducts({
      currentPage: 1,
      itemsPerPage: 9999, // Load all products
      sortBy: 'product_code',
      sortOrder: 1
    });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mode !== this.props.mode) {
      this.setState({ mode: this.props.mode });
    }

    if (prevProps.currentQtyChange !== this.props.currentQtyChange) {
      this.initializeFormData();
    }
  }

  initializeFormData = () => {
    const { currentQtyChange, mode } = this.props;
    
    if (currentQtyChange) {
      this.setState({
        formData: { ...currentQtyChange },
        mode: mode || 'view'
      });
    } else {
      this.setState({
        formData: this.getDefaultFormData(),
        mode: 'edit'
      });
    }
  };

  handleEdit = () => {
    const { formData } = this.state;
    this.setState({
      mode: 'edit',
      formData: { ...formData }
    });
  };

  handleClose = () => {
    const { currentQtyChange } = this.props;
    if (currentQtyChange) {
      this.setState({
        mode: 'view',
        formData: { ...currentQtyChange }
      });
    }
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  handleSubmit = () => {
    this.setState({ saving: true });
    const { formData } = this.state;

    console.log("formData", formData);
    
    this.props.setSESProductQtyChanges([formData], { create_new: true })
      // .then(() => {
      //   if (this.props.currentQtyChange) {
      //     this.setState({ 
      //       mode: 'view',
      //       saving: false
      //     });
      //   } else {
      //     this.handleClose();
      //   }
      // })
      // .catch(error => {
      //   console.error('Error saving quantity change:', error);
      //   alert('Failed to save quantity change. See console for details.');
      //   this.setState({ saving: false });
      // });
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState(prevState => {
      const newFormData = {
        ...prevState.formData,
        [name]: value
      };
      
      // If quantity_change is updated, recalculate quantity
      if (name === 'quantity_change') {
        newFormData.quantity = parseInt(newFormData.old_quantity || 0, 10) + parseInt(value || 0, 10);
      }
      
      return { formData: newFormData };
    });
  };

  handleProductChange = (selectedOption) => {
    const selectedProduct = this.props.products.find(p => p.product_code === selectedOption.value);
    const oldQuantity = selectedProduct ? selectedProduct.current_qty || 0 : 0;
    const currentCellCode = selectedProduct ? selectedProduct.current_cell_code || '' : '';
    
    this.setState(prevState => ({
      formData: {
        ...prevState.formData,
        product_code: selectedOption ? selectedOption.value : '',
        old_quantity: oldQuantity,
        quantity: oldQuantity + (prevState.formData.quantity_change || 0),
        warehouse_cell_code: currentCellCode
      }
    }));
  };

  calculateNewQuantity = () => {
    const { formData } = this.state;
    if (!formData) return 0;
    
    const oldQuantity = parseInt(formData.quantity || 0, 10);
    const changeAmount = parseInt(formData.quantity_change || 0, 10);
    return oldQuantity + changeAmount;
  };

  generateCellCodes = () => {
    const cellCodes = [];
    const letters = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
    
    letters.forEach(letter => {
      for (let x = 1; x <= 8; x++) {
        for (let y = 1; y <= 3; y++) {
          cellCodes.push(`${letter}${x}${y}`);
        }
      }
    });
    
    return cellCodes;
  };

  render() {
    const { mode, formData, saving } = this.state;
    const { show, currentQtyChange, products } = this.props;
    const isEditMode = mode === 'edit';
    const isNew = !currentQtyChange;
    const newQuantity = this.calculateNewQuantity();

    if (!formData) return null;

    const productOptions = products ? products.map(product => ({
      value: product.product_code,
      label: (
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <span>{product.product_code}</span>
          <span style={{ color: '#666', marginLeft: '10px' }}>{product.product_name}</span>
        </div>
      )
    })) : [];

    const cellCodeOptions = this.generateCellCodes().map(code => ({
      value: code,
      label: code
    }));

    const selectedProduct = productOptions.find(option => option.value === formData.product_code);
    const selectedCellCode = cellCodeOptions.find(option => option.value === formData.warehouse_cell_code);

    // Custom styles for react-select
    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        padding: '8px 12px',
        cursor: 'pointer',
        backgroundColor: state.isFocused ? '#f0f0f0' : 'white',
        '&:hover': {
          backgroundColor: '#f0f0f0'
        }
      }),
      menu: (provided) => ({
        ...provided,
        zIndex: 9999,
        maxHeight: '400px'
      }),
      menuList: (provided) => ({
        ...provided,
        maxHeight: '400px'
      })
    };

    return (
      <Modal
        show={show}
        onHide={this.handleClose}
        size="lg"
        centered
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <div className="d-flex justify-content-between align-items-center w-100">
            <Modal.Title>
              {isNew ? getTranslate(LANGUAGE_KEYS.TEXT_ADD_NEW_QUANTITY_CHANGE) : (mode === 'view' ? getTranslate(LANGUAGE_KEYS.TEXT_VIEW_QUANTITY_CHANGE) : getTranslate(LANGUAGE_KEYS.TEXT_EDIT_QUANTITY_CHANGE))}
            </Modal.Title>
            {isNew || mode === 'edit' ? (
              <Button 
                variant="success" 
                onClick={this.handleSubmit}
                disabled={saving}
              >
                {saving ? (
                  <>
                    <Spinner
                      as="span"
                      animation="border"
                      size="sm"
                      role="status"
                      aria-hidden="true"
                      className="me-2"
                    />
                    {getTranslate(LANGUAGE_KEYS.TEXT_SAVING)}...
                  </>
                ) : (
                  getTranslate(LANGUAGE_KEYS.TEXT_SAVE)
                )}
              </Button>
            ) : (
              <Button 
                variant="primary" 
                onClick={this.handleEdit}
              >
                <FaEdit /> {getTranslate(LANGUAGE_KEYS.TEXT_EDIT)}
              </Button>
            )}
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_PRODUCT_CODE)}</Form.Label>
                  <Select
                    value={selectedProduct}
                    onChange={this.handleProductChange}
                    options={productOptions}
                    isDisabled={!isEditMode}
                    isClearable
                    placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SEARCH_PRODUCT_CODE_OR_NAME) || "Search product code or name..."}
                    noOptionsMessage={() => getTranslate(LANGUAGE_KEYS.TEXT_NO_PRODUCTS_FOUND) || "No products found"}
                    styles={{ ...customStyles, container: base => ({ ...base, width: '100%' }) }}
                    isSearchable={true}
                    formatOptionLabel={option => option.label}
                    components={{
                      Option: ({ children, ...props }) => (
                        <div {...props.innerProps}>
                          {children}
                        </div>
                      )
                    }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_WAREHOUSE_ID)}</Form.Label>
                  <Form.Control
                    type="number"
                    name="warehouse_id"
                    value={formData.warehouse_id || 1}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CELL_CODE)}</Form.Label>
                  <Select
                    value={selectedCellCode}
                    onChange={(option) => this.handleInputChange({
                      target: {
                        name: 'warehouse_cell_code',
                        value: option ? option.value : ''
                      }
                    })}
                    options={cellCodeOptions}
                    isDisabled={!isEditMode}
                    isClearable
                    placeholder={getTranslate(LANGUAGE_KEYS.TEXT_SELECT_CELL_CODE) || "Select a cell code..."}
                    noOptionsMessage={() => getTranslate(LANGUAGE_KEYS.TEXT_NO_CELL_CODES_FOUND) || "No cell codes found"}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_OLD_QUANTITY)}</Form.Label>
                  <Form.Control
                    type="number"
                    name="old_quantity"
                    value={formData.old_quantity || 0}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_CHANGE_AMOUNT)}</Form.Label>
                  <Form.Control
                    type="number"
                    name="quantity_change"
                    value={formData.quantity_change || 0}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_NEW_QUANTITY)}</Form.Label>
                  <Form.Control
                    type="number"
                    name="quantity"
                    value={formData.quantity || 0}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_TYPE)}</Form.Label>
                  <Form.Select
                    name="type"
                    value={formData.type || 'IMPORT'}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  >
                    <option value="IMPORT">{getTranslate(LANGUAGE_KEYS.TEXT_IMPORT)}</option>
                    <option value="EXPORT">{getTranslate(LANGUAGE_KEYS.TEXT_EXPORT)}</option>
                    <option value="ADJUSTMENT">Adjustment</option>
                    <option value="RETURN">Return</option>
                    <option value="DAMAGED">Damaged</option>
                    <option value="LOST">Lost</option>
                    <option value="INVENTORY_CHECK">{getTranslate(LANGUAGE_KEYS.TEXT_INVENTORY_CHECK)}</option>
                    <option value="OTHER">Other</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_REFERENCE_ID)}</Form.Label>
                  <Form.Control
                    type="text"
                    name="reference_id"
                    value={formData.reference_id || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_SYSTEM_NOTE)}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={2}
                    name="system_note"
                    value={formData.system_note || ''}
                    onChange={this.handleInputChange}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={12}>
                <Form.Group className="mb-3">
                  <Form.Label>{getTranslate(LANGUAGE_KEYS.TEXT_STAFF_NOTE)}</Form.Label>
                  <Form.Control
                    as="textarea"
                    rows={3}
                    name="staff_note"
                    value={formData.staff_note || ''}
                    onChange={this.handleInputChange}
                    disabled={!isEditMode}
                  />
                </Form.Group>
              </Col>
            </Row>

            {!isNew && (
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Updated By</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.updated_by || ''}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Last Updated</Form.Label>
                    <Form.Control
                      type="text"
                      value={formData.updated_at ? new Date(formData.updated_at).toLocaleString() : ''}
                      disabled={true}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.handleClose}>
            {getTranslate(LANGUAGE_KEYS.TEXT_CLOSE)}
          </Button>
          {isEditMode && (
            <Button variant="success" onClick={this.handleSubmit} disabled={saving}>
              {getTranslate(LANGUAGE_KEYS.TEXT_SAVE)}
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  products: state.sesProductReducer.products
});

export default connect(mapStateToProps, {
  setSESProductQtyChanges,
  getSESProducts
})(SESProductQtyChangeModal); 